import requester from '@zg-rentals/particles-js-requester';

import { FILE_PROXY_PATH, PROXY_PATH, RENTAL_GROWTH_PROXY_PATH } from '../constants/RouteConstants';
import { getGlobalLogger } from '@zg-rentals/logger-base';

// TODO: delete after all comet apps are onboarded to perimeterx (ZRM-11233)
const ENABLE_PX_HEADER = { 'Zg-Via-Server': 'zillow-rental-manager-web' };

const client = (zgApi: string) =>
  requester({
    proxyPath: PROXY_PATH,
    api: typeof window === 'undefined' ? zgApi : '',
    logger: getGlobalLogger('requester'),
    headers: { ...ENABLE_PX_HEADER },
  });

const growthClient = () =>
  requester({
    proxyPath: RENTAL_GROWTH_PROXY_PATH,
    api: typeof window === 'undefined' ? process.env.ZG_GROWTH_API : '',
    logger: getGlobalLogger('growthRequester'),
  });

const growthGraphQLClient = () =>
  requester({
    proxyPath: RENTAL_GROWTH_PROXY_PATH,
    api: typeof window === 'undefined' ? process.env.ZG_GROWTH_API : '',
    logger: getGlobalLogger('growthGraphQLRequester'),
    headers: {
      'content-type': 'text/plain',
    },
  });

const fileClient = (zgApi: string) =>
  requester({
    proxyPath: FILE_PROXY_PATH,
    api: typeof window === 'undefined' ? zgApi : '',
    logger: getGlobalLogger('fileProxyRequester'),
    headers: { ...ENABLE_PX_HEADER },
  });

const noProxyClient = (zgApi: string) =>
  requester({
    api: typeof window === 'undefined' ? zgApi : '',
    logger: getGlobalLogger('noProxyRequester'),
    headers: { ...ENABLE_PX_HEADER },
  });

export { client, growthClient, growthGraphQLClient, fileClient, noProxyClient };
